<div [formGroup]="tableauConfigurationFormGroup">
  <div class="card mt-2">
    <div (click)="collapse.toggle()"
      [style.cursor]="'pointer'"
      class="card-header">
      <div class="row align-items-center">
        <div class="col">
          <span class="card-title" translate>Tableau configuration</span>
        </div>

        @if (!isDetailsAreaCollapsed) {
          <div class="col-auto">
            <button (click)="verifyTableauConfiguration($event)"
              [disabled]="hasInvalidConfiguration"
              class="btn btn-sm btn-outline-primary"
              type="button">
              <span translate>Verify configuration</span>
            </button>
            @if (isVerificationInProgress) {
              <span class="fa-solid fa-spinner fa-spin ml-2"></span>
            }
            @if (!hasInvalidConfiguration && configurationVerified===true) {
              <span
                [title]="'The configuration is valid'|translate"
                class="fa-solid fa-circle-check text-success ml-2"
              ></span>
            }
            @if (hasInvalidConfiguration || configurationVerified===false) {
              <span
                [title]="'The configuration is invalid'|translate"
              class="fa-solid fa-circle-xmark text-danger ml-2"></span>
            }
          </div>
        }

        <div class="col-auto">
          <button (click)="$event.stopPropagation();collapse.toggle()" [attr.aria-expanded]="!isDetailsAreaCollapsed"
            aria-controls="collapseExample"
            class="btn btn-sm btn-outline-primary"
            type="button">
            @if (isDetailsAreaCollapsed) {
              <span [title]="'Show configuration' | translate"
              class="fa-solid fa-chevron-down"></span>
            }
            @if (!isDetailsAreaCollapsed) {
              <span [title]="'Hide configuration' | translate"
              class="fa-solid fa-chevron-up"></span>
            }
          </button>
        </div>
      </div>
    </div>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isDetailsAreaCollapsed" class="card-body">
      <!--TABLEAU SERVER & CLOUD -->
      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <div class="row">
              <div class="col-6">
                <div class="form-check d-inline-block mr-3">
                  <input (change)="onInputValueChange()"
                    [checked]="formControls.isTableauCloud.getRawValue()" [value]="true"
                    class="form-check-input"
                    formControlName="isTableauCloud"
                    id="tableauCloud"
                    name="isTableauCloud" type="radio">
                    <label class="form-check-label" for="tableauCloud" translate>Tableau Cloud</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-check d-inline-block">
                    <input (change)="onInputValueChange()"
                      [checked]="!formControls.isTableauCloud.getRawValue()"
                      [value]="false" class="form-check-input"
                      formControlName="isTableauCloud"
                      id="tableauServer"
                      name="isTableauCloud" type="radio">
                      <label class="form-check-label" for="tableauServer" translate>Tableau Server</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--CLIENT ID & SECRET ID -->
          <div class="form-row">
            <!-- CLIENT ID -->
            <div class="col-12 col-lg-6">
              <div class="form-group">
                <label for="clientId" translate>Client id</label>
                @if (!noTableauConfigurationSet) {
                  <scitis-required-field-indicator></scitis-required-field-indicator>
                }
                <input (change)="onInputValueChange()"
                  [ngClass]="{ 'is-invalid': formControls.clientId.errors }" class="form-control"
                  formControlName="clientId" id="clientId"
                  name="clientId"
                  type="password">
                  @if (formControls.clientId.errors) {
                    <div
                      class="invalid-feedback">
                      @if (formControls.clientId.errors.notFilled) {
                        <span translate>Client id is required</span>
                      }
                    </div>
                  }
                </div>
              </div>

              <!-- SECRET ID -->
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label for="secretId" translate>Secret id</label>
                  @if (!noTableauConfigurationSet) {
                    <scitis-required-field-indicator></scitis-required-field-indicator>
                  }
                  <input (change)="onInputValueChange()"
                    [ngClass]="{ 'is-invalid': formControls.secretId.errors }" class="form-control"
                    formControlName="secretId" id="secretId"
                    name="secretId"
                    type="password">
                    @if (formControls.secretId.errors) {
                      <div
                        class="invalid-feedback">
                        @if (formControls.secretId.errors.notFilled) {
                          <span translate>Secret is required</span>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <!-- SECRET VALUE -->
              <div class="form-row">
                <div class="col-12 col-lg-12">
                  <div class="form-group">
                    <label for="secretValue" translate>Secret value</label>
                    @if (!noTableauConfigurationSet) {
                      <scitis-required-field-indicator></scitis-required-field-indicator>
                    }
                    <input (change)="onInputValueChange()"
                      [ngClass]="{ 'is-invalid': formControls.secretValue.errors }"
                      class="form-control"
                      formControlName="secretValue" id="secretValue"
                      name="secretValue"
                      type="password">
                      @if (formControls.secretValue.errors) {
                        <div
                          class="invalid-feedback">
                          @if (formControls.secretValue.errors.notFilled) {
                            <span translate>Secret value is required</span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <!-- URL -->
                <div class="form-row">
                  <div class="col-12 col-lg-12">
                    <div class="form-group">
                      <label for="url" translate>Site URL</label>
                      @if (!noTableauConfigurationSet) {
                        <scitis-required-field-indicator></scitis-required-field-indicator>
                      }
                      <input (change)="onInputValueChange()"
                        [ngClass]="{ 'is-invalid': formControls.url.errors }"
                        class="form-control"
                        formControlName="url" id="url"
                        name="url"
                        type="text">
                        @if (formControls.url.errors) {
                          <div
                            class="invalid-feedback">
                            @if (formControls.url.errors.notFilled) {
                              <span translate>Tableau URL is required</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <!--  USER NAME & SITE NAME-->
                  <div class="form-row">
                    <!-- USER NAME -->
        <div [ngClass]="{
        'col-lg-6':formControls.isTableauCloud.getRawValue(),
        'col-lg-5':!formControls.isTableauCloud.getRawValue()
        }" class="col-12">
                      <div class="form-group">
                        <label for="userName" translate>User name</label>
                        @if (!noTableauConfigurationSet) {
                          <scitis-required-field-indicator></scitis-required-field-indicator>
                        }
                        <input (change)="onInputValueChange()"
                          [ngClass]="{ 'is-invalid':  formControls.userName.errors }" class="form-control"
                          formControlName="userName" id="userName"
                          name="userName"
                          type="text">
                          @if (formControls.userName.errors) {
                            <div
                              class="invalid-feedback">
                              @if (formControls.userName.errors.notFilled) {
                                <span translate>User name is required</span>
                              }
                            </div>
                          }
                        </div>
                      </div>

                      <!-- SITE NAME -->
        <div [ngClass]="{
        'col-lg-6':formControls.isTableauCloud.getRawValue(),
        'col-lg-5':!formControls.isTableauCloud.getRawValue()
        }" class="col-12">
                        <div class="form-group">
                          <label for="siteName" translate>Site name</label>
                          @if (!noTableauConfigurationSet) {
                            <scitis-required-field-indicator></scitis-required-field-indicator>
                          }
                          <input (change)="onInputValueChange()"
                            [ngClass]="{ 'is-invalid': formControls.siteName.errors }" class="form-control"
                            formControlName="siteName" id="siteName"
                            name="siteName"
                            type="text">
                            @if (formControls.siteName.errors) {
                              <div
                                class="invalid-feedback">
                                @if (formControls.siteName.errors.notFilled) {
                                  <span translate>Site name is required</span>
                                }
                              </div>
                            }
                          </div>
                        </div>
                        @if (!formControls.isTableauCloud.getRawValue()) {
                          <div class="col-12 col-lg-2">
                            <div class="form-group">
                              <label for="isDefaultSite" translate>Default site</label>
                              <div class="custom-control custom-switch d-inline-flex">
                                <input (change)="onInputValueChange()"
                                  class="custom-control-input"
                                  formControlName="isDefaultSite" id="isDefaultSite"
                                  name="isDefaultSite"
                                  type="checkbox">
                                  <label class="custom-control-label" for="isDefaultSite"> </label>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
